import { Route, Navigate } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const RecettesPage = lazy(() => import("@/pages/fiches/RecettesPage"));
const CommandesSpecialesPage = lazy(() => import("@/pages/fiches/CommandesSpecialesPage"));
const FichesDashboardPage = lazy(() => import("@/pages/fiches/FichesDashboardPage"));
const CarteDuJourPage = lazy(() => import("@/pages/menu/CarteDuJourPage"));
const BonsCommandePage = lazy(() => import("@/pages/achats/BonsCommandePage"));
const BonCommandeDetailPage = lazy(() => import("@/pages/achats/BonCommandeDetailPage"));
const ReceptionsPage = lazy(() => import("@/pages/achats/ReceptionsPage"));
const AvoirsDusPage = lazy(() => import("@/pages/achats/AvoirsDusPage"));
const FournisseursPage = lazy(() => import("@/pages/achats/FournisseursPage"));
const DeclarerPertePage = lazy(() => import("@/pages/pertes/DeclarerPertePage"));
const HistoriquePertesPage = lazy(() => import("@/pages/pertes/HistoriquePertesPage"));
const BonsCaissePage = lazy(() => import("@/pages/depenses/BonsCaissePage"));
const ClotureDepensesPage = lazy(() => import("@/pages/depenses/ClotureDepensesPage"));
const ImportRapportZPage = lazy(() => import("@/pages/recettes/ImportRapportZPage"));
const ClotureRecettesPage = lazy(() => import("@/pages/recettes/ClotureRecettesPage"));
const SaisiePourboiresPage = lazy(() => import("@/pages/pourboires/SaisiePourboiresPage"));
const RepartitionPourboiresPage = lazy(() => import("@/pages/pourboires/RepartitionPourboiresPage"));
const HistoriquePourboiresPage = lazy(() => import("@/pages/pourboires/HistoriquePourboiresPage"));
const VentesPage = lazy(() => import("@/pages/caisse/VentesPage"));

export function achatsMetierRoutes() {
  return (
    <>
      {/* Fiches techniques */}
      <Route
        path="/fiches/dashboard"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FichesDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fiches/recettes"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <RecettesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fiches/commandes-speciales"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "gestionnaire", "controleur", "gerante", "pdg", "caissiere", "admin"]}>
            <CommandesSpecialesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/menu/carte-du-jour"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <CarteDuJourPage />
          </ProtectedRoute>
        }
      />

      {/* Achats */}
      <Route
        path="/achats/bons-commande"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "caissiere", "admin"]}>
            <BonsCommandePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/achats/bons-commande/:id"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "caissiere", "pdg", "admin"]}>
            <BonCommandeDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/achats/receptions"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "caissiere", "admin"]}>
            <ReceptionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/achats/avoirs"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "caissiere", "admin"]}>
            <AvoirsDusPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/achats/fournisseurs"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "admin"]}>
            <FournisseursPage />
          </ProtectedRoute>
        }
      />

      {/* Pertes */}
      <Route
        path="/pertes/declarer"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "gestionnaire", "controleur", "gerante", "admin"]}>
            <DeclarerPertePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pertes/historique"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "admin"]}>
            <HistoriquePertesPage />
          </ProtectedRoute>
        }
      />

      {/* Dépenses */}
      <Route
        path="/depenses/bons"
        element={
          <ProtectedRoute allowedRoles={["barman", "gestionnaire", "controleur", "gerante", "caissiere", "admin"]}>
            <BonsCaissePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/depenses/cloture"
        element={
          <ProtectedRoute allowedRoles={["gerante", "caissiere", "admin"]}>
            <ClotureDepensesPage />
          </ProtectedRoute>
        }
      />

      {/* Recettes */}
      <Route
        path="/recettes/import"
        element={
          <ProtectedRoute allowedRoles={["gerante", "caissiere", "admin"]}>
            <ImportRapportZPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recettes/cloture"
        element={
          <ProtectedRoute allowedRoles={["controleur", "gerante", "pdg", "caissiere", "admin"]}>
            <ClotureRecettesPage />
          </ProtectedRoute>
        }
      />

      {/* Pourboires */}
      <Route
        path="/pourboires/saisie"
        element={
          <ProtectedRoute allowedRoles={["barman", "serveur", "chef_salle", "gerante", "caissiere", "admin"]}>
            <SaisiePourboiresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pourboires/repartition"
        element={
          <ProtectedRoute allowedRoles={["gerante", "caissiere", "admin"]}>
            <RepartitionPourboiresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pourboires/historique"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "serveur", "chef_salle", "controleur", "gerante", "caissiere", "admin"]}>
            <HistoriquePourboiresPage />
          </ProtectedRoute>
        }
      />

      {/* Ventes */}
      <Route
        path="/caisse/ventes"
        element={
          <ProtectedRoute allowedRoles={["barman", "gerante", "caissiere", "admin"]}>
            <VentesPage />
          </ProtectedRoute>
        }
      />

      {/* Redirections legacy /caisse/* */}
      <Route path="/caisse/depenses" element={<Navigate to="/depenses/bons" replace />} />
      <Route path="/caisse/recettes" element={<Navigate to="/recettes/import" replace />} />
      <Route path="/caisse/pourboires" element={<Navigate to="/pourboires/saisie" replace />} />
    </>
  );
}
